export default __webpack_public_path__ + "static/media/t15.df2d009b.jpg";